(function () {
  var root = document.querySelector('[data-widerruf-form]');
  if (!root) return;

  var formEl = root.querySelector('#widerruf-form');
  if (!formEl) return;

  var stepForm = root.querySelector('[data-step="form"]');
  var stepSummary = root.querySelector('[data-step="summary"]');
  var stepSuccess = root.querySelector('[data-step="success"]');
  var statusEl = root.querySelector('[data-widerruf-status]');
  var companyId = root.getAttribute('data-klaviyo-company-id') || 'V6z2iM';
  var eventName = root.getAttribute('data-klaviyo-event') || 'Widerruf Submitted';

  var fields = {
    firstName: root.querySelector('#widerruf-firstname'),
    lastName: root.querySelector('#widerruf-lastname'),
    email: root.querySelector('#widerruf-email'),
    orderNumber: root.querySelector('#widerruf-ordernumber'),
    additionalInfo: root.querySelector('#widerruf-additional'),
    privacy: root.querySelector('#widerruf-privacy')
  };

  function valueOf(el) {
    return el ? String(el.value || '').trim() : '';
  }

  function setInvalid(el, invalid) {
    var wrap = el && el.closest('.wd__field, .wd__privacy');
    if (el && el.classList) el.classList.toggle('is-invalid', invalid);
    if (wrap) wrap.classList.toggle('is-invalid', invalid);
  }

  function validate() {
    var ok = true;
    ['firstName', 'lastName', 'email', 'orderNumber'].forEach(function (key) {
      var el = fields[key];
      var valid = valueOf(el).length > 0;
      if (key === 'email') valid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(valueOf(el));
      setInvalid(el, !valid);
      if (!valid) ok = false;
    });
    var privacyOk = fields.privacy && fields.privacy.checked;
    setInvalid(fields.privacy, !privacyOk);
    if (!privacyOk) ok = false;
    if (!ok) {
      var firstInvalid = root.querySelector('.wd__field.is-invalid, .wd__privacy.is-invalid');
      if (firstInvalid && firstInvalid.scrollIntoView) {
        firstInvalid.scrollIntoView({ block: 'center' });
      }
    }
    return ok;
  }

  function fillSummary() {
    root.querySelectorAll('[data-summary]').forEach(function (dd) {
      var key = dd.getAttribute('data-summary');
      var val = key === 'additionalInfo' ? valueOf(fields.additionalInfo) : valueOf(fields[key]);
      dd.textContent = val || '—';
    });
  }

  function showStep(name) {
    [stepForm, stepSummary, stepSuccess].forEach(function (step) {
      if (!step) return;
      step.hidden = step.getAttribute('data-step') !== name;
    });
    if (statusEl) {
      statusEl.hidden = true;
      statusEl.textContent = '';
    }
  }

  function showStatus(message) {
    if (!statusEl) return;
    statusEl.hidden = false;
    statusEl.textContent = message;
  }

  function payload() {
    return {
      email: valueOf(fields.email),
      first_name: valueOf(fields.firstName),
      last_name: valueOf(fields.lastName),
      order_number: valueOf(fields.orderNumber),
      additional_info: valueOf(fields.additionalInfo)
    };
  }

  function ensureKlaviyoStub() {
    if (!window.klaviyo) window.klaviyo = [];
    if (document.querySelector('script[src*="klaviyo"]')) return;
    var script = document.createElement('script');
    script.async = true;
    script.src = 'https://static.klaviyo.com/onsite/js/klaviyo.js?company_id=' + encodeURIComponent(companyId);
    document.head.appendChild(script);
  }

  function submitToKlaviyo() {
    var data = payload();
    var identity = {
      email: data.email,
      $email: data.email,
      first_name: data.first_name,
      last_name: data.last_name,
      $first_name: data.first_name,
      $last_name: data.last_name
    };
    var properties = {
      first_name: data.first_name,
      last_name: data.last_name,
      email: data.email,
      order_number: data.order_number,
      additional_info: data.additional_info,
      source: 'widerruf-form'
    };

    ensureKlaviyoStub();
    if (!window.klaviyo || typeof window.klaviyo.push !== 'function') {
      return Promise.reject(new Error('Klaviyo unavailable'));
    }

    // push() queues the event. Do not await identify()/track() — the Klaviyo
    // Proxy returns a Promise that never settles when Client API CORS hangs
    // (common on http://127.0.0.1 theme preview).
    window.klaviyo.push(['identify', identity]);
    window.klaviyo.push(['track', eventName, properties]);
    return Promise.resolve();
  }

  formEl.addEventListener('submit', function (event) {
    event.preventDefault();
    event.stopPropagation();
    if (!validate()) return;
    fillSummary();
    showStep('summary');
  });

  root.querySelectorAll('[data-widerruf-back]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      showStep('form');
    });
  });

  root.querySelectorAll('[data-widerruf-confirm]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (btn.disabled) return;
      var original = btn.textContent;
      btn.disabled = true;
      btn.textContent = 'Wird gesendet…';
      submitToKlaviyo()
        .then(function () {
          showStep('success');
        })
        .catch(function () {
          showStatus('Der Widerruf konnte nicht gesendet werden. Bitte versuche es erneut oder schreibe an support@myebikes.com.');
          btn.textContent = original;
          btn.disabled = false;
        });
    });
  });
})();
